import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import { UserLean } from 'legacy/user/types';
import React from 'react';
import UserRow from '../UserRow';

interface Props {
  isLoading: boolean;
  users: UserLean[];
  onSelect: (user: UserLean) => void;
  selectedUsers: UserLean[];
  search: string;
  onClearAll: () => void;
}

const UserList = ({
  isLoading,
  users,
  onSelect,
  selectedUsers,
  search,
  onClearAll
}: Props) => {
  if (!isLoading && users && users?.length === 0) {
    return (
      <div className="h-[30vh] flex flex-col items-center justify-center mt-6">
        <p className="text-base font-normal mt-4"> No Users found </p>
      </div>
    );
  }
  const showClearButton = selectedUsers.length > 0 && search === '';
  return (
    <div className="w-full h-[30vh]">
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner type={SpinnerType.PRIMARY} />
        </div>
      ) : (
        <>
          {showClearButton && (
            <div className="flex flex-row justify-between items-center rounded-full my-6">
              <p className="text-sm mt-4 text-[#202020] font-bold">
                {selectedUsers.length} Bounce Users
              </p>
              <button
                type="button"
                className="text-sm font-normal text-[#3853C4] text-bold"
                onClick={onClearAll}
              >
                Clear
              </button>
            </div>
          )}
          <ul className="flex flex-col gap-2">
            {users.map((user) => (
              <UserRow
                key={user._id}
                name={user.name}
                onSelect={() => onSelect(user)}
                id={user._id}
                image={user?.photo?.url}
                isSelected={selectedUsers.includes(user)}
                isDisabled={false}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default UserList;
